import './credit-card.scss';
import { Card } from 'reactstrap';
import { Trash } from 'react-feather';
import { useTranslation } from 'react-i18next';

interface CreditCardProps {
  suffix: string;
  expiration: string;
  brand: string;
  onClickRemove?: () => void;
  hideRemoveButton?: boolean;
}

const CreditCard = (props: CreditCardProps) => {
  const { t } = useTranslation();

  return (
    <Card className="credit-card">
      <div className="credit-card-content">
        <div className="credit-card-logo">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Visa_Inc._logo.svg/2560px-Visa_Inc._logo.svg.png"
            alt="credit card logo"
          />
        </div>
        <div className="credit-card-details">
          <div className="credit-card-number">
            ****
            {props.suffix.toString().slice(props.suffix.toString().length - 4)}
          </div>
          <div className="credit-card-details-line" />
          <div className="credit-card-expires">
            Expires{' '}
            {`${props.expiration.slice(0, 2)}/${props.expiration.slice(2, 4)}`}
          </div>
        </div>
      </div>
      {!props.hideRemoveButton && (
        <div className="credit-card-button" onClick={props.onClickRemove}>
          <Trash size={16} />
          <span>{t('REMOVE_CREDIT_CARD')}</span>
        </div>
      )}
    </Card>
  );
};

export default CreditCard;
